import { combineReducers } from 'redux';

import { META_SOURCE_UPLOAD } from 'constants/ReleaseConstants';
import { UPLOAD_MEDIAS, UPLOAD_MEDIAS_FAILURE } from 'modules/medias/actionTypes';
import * as types from 'modules/releases/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *  open: boolean,
 *  releaseId: string | null,
 *  noteId: string | null,
 *  importing: boolean,
 * }} ReleaseNoteModalReducer
 */
export default combineReducers({
  open: createReducer(false, {
    [LOCATION_CHANGE]: () => false,
    [types.OPEN_NOTE_CSV_MODAL]: () => true,
    [types.CLOSE_NOTE_CSV_MODAL]: () => false,
  }),
  releaseId: createReducer(null, {
    [LOCATION_CHANGE]: () => null,
    [types.OPEN_NOTE_CSV_MODAL]: () => null,
    [types.CLOSE_NOTE_CSV_MODAL]: (_, { payload }) => payload?.releaseId ?? null,
  }),
  importing: createReducer(false, {
    [types.CLOSE_NOTE_CSV_MODAL]: () => false,
  }, [
    {
      matcher: ({ type, meta }) => type === UPLOAD_MEDIAS && meta.source === META_SOURCE_UPLOAD,
      reducer: () => true,
    },
    {
      matcher: ({ type, meta }) => type === UPLOAD_MEDIAS_FAILURE && meta.source === META_SOURCE_UPLOAD,
      reducer: () => false,
    }
  ])

});
